import {Component, Inject, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';
import {DatePipe, NgForOf, NgIf} from '@angular/common';
import {LimitToPipe} from '../pipes/limit-to.pipe';
import {DisplayPipe} from '../pipes/display.pipe';
import {PhoneNumberPipe} from '../pipes/phone-number.pipe';
import {ToStringPipe} from '../pipes/to-string.pipe';
import {IsImagePipe} from '../pipes/is-image.pipe';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
    selector: 'app-display-field',
    templateUrl: './display-field.component.html',
    styleUrls: ['./display-field.component.css'],
    imports: [
        NgbTooltipModule,
        DatePipe,
        LimitToPipe,
        DisplayPipe,
        NgIf,
        PhoneNumberPipe,
        ToStringPipe,
        NgForOf,
        IsImagePipe
    ]
})
export class DisplayFieldComponent implements OnChanges {
  @Input() getChoices;
  @Input() value;
  @Input() type;
  @Input() choices;
  @Input() showLabel;
  @Input() allowLong;
  @Input() icons;
  @Input() meta;
  downloadUrl;
  loading = false;

  constructor(@Inject('environment') private environment,
              private sanitizer: DomSanitizer) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.hasOwnProperty('value')) {
      if (changes.value.currentValue !== changes.value.previousValue && this.getChoices) {
        this.loading = true;
        this.getChoices(changes.value.currentValue)
          .then(choices => {
          this.choices = choices;
        }).finally(() => this.loading = false);
      }
    }
    if (this.type === 'attachment' && this.meta && this.value?.globalid) {
      this.downloadUrl = `${this.environment.baseUrl}/${this.meta.attachments_url}/${this.value.globalid}/download/`;
    } else {
      this.downloadUrl = null;
    }
  }

  viewImage(attachment, e) {
    e.stopPropagation();
    const binary = atob(attachment.base64.replace(/\s/g, ''));
    const len = binary.length;
    const buffer = new ArrayBuffer(len);
    const view = new Uint8Array(buffer);
    for (let i = 0; i < len; i++) {
      view[i] = binary.charCodeAt(i);
    }
    const file = new Blob([view], {type: attachment.filetype});
    const fileURL = window.URL.createObjectURL(file);
    window.open(fileURL, '_blank');
  }



  public allowBase64(srcString: string): any {
    return this.sanitizer.bypassSecurityTrustResourceUrl(srcString)
  }

}
